<template>
  <v-container fluid>
    <form action @submit.prevent="submitForm">
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="success" v-if="success">
        <p>{{ success }}</p>
      </div>

      <div class="feedback-info">
        <p>
          {{ $t("app.feedback.intro-1a") }}
          <a href="/settings/faq">{{ $t("app.feedback.faq-page") }}</a>
          {{ $t("app.feedback.intro-1b") }}
        </p>
      </div>

      <div class="field">
        <div class="select-input">
          <label>{{ $t("app.feedback.form-category") }}</label>
          <span class="pink--text">*</span>
          <select required v-model="form.category">
            <option disabled value selected>{{
              $t("app.feedback.form-category-placeholder")
              }}</option>
            <option value="Account">{{
              $t("app.feedback.category.account")
              }}</option>
            <option value="Inhoud">{{
              $t("app.feedback.category.content")
              }}</option>
            <option value="Bug">{{ $t("app.feedback.category.bug") }}</option>
            <option value="Weergave">{{
              $t("app.feedback.category.display")
              }}</option>
            <option value="Andere">{{
              $t("app.feedback.category.other")
              }}</option>
          </select>
        </div>

        <InputField
          v-model="form.subject"
          :labelTitle="$t('app.feedback.form-subject')"
          required
          :placeholder="$t('app.feedback.form-subject-placeholder')"
          margin="25px auto"
        ></InputField>

        <TextAreaField
          v-model="form.description"
          required
          :labelTitle="$t('app.feedback.form-description')"
          :placeholder="$t('app.feedback.form-description-placeholder')"
          margin="0 auto 25px auto"
        ></TextAreaField>

        <div class="consent-checkbox">
          <label for="contactConsent" class="checkbox-container">
            {{ $t("app.feedback.contact-consent") }}
            <input
              type="checkbox"
              id="contactConsent"
              v-model="form.contactConsent"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <LoadingButton v-if="loading" margin="0 auto 25px auto"></LoadingButton>
        <Button
          v-else
          type="submit"
          :title="$t('app.feedback.action-send')"
          margin="0 auto 25px auto"
        ></Button>
      </div></form
    ></v-container>
</template>

<script>
import { neoparentFeedback } from "@/api";

export default {
  name: "neoparent-report-problem",
  data() {
    return {
      success: "",
      error: "",
      form: {
        category: "",
        subject: "",
        description: "",
        contactConsent: false
      },
      loading: false
    };
  },
  mounted() {},
  methods: {
    submitForm() {
      if (confirm(this.$t("app.feedback.confirm"))) {
        this.loading = true;

        const data = {
          category: this.form.category,
          subject: this.form.subject,
          description: this.form.description,
          contactConsent: this.form.contactConsent
        };

        neoparentFeedback
          .sendBugReport(data)
          .then(result => {
            this.consoleLog(result);
            this.consoleLog("Email sent");
            this.success = this.$t("success.feedback-sent");
            this.error = "";
            window.scrollTo(0, 0);
            this.loading = false;
          })
          .catch(err => {
            this.consoleLog(err);
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
